export function epageToPageNumber(epage) {
    return Math.round(epage + 1);
}
export function epageFromPageNumber(pageNumber) {
    return pageNumber - 1;
}
//# sourceMappingURL=epage.js.map